export enum UserTypes {
  admin = 0,
  owner = 1,
}
